module.exports = __webpack_public_path__ + "static/media/README.faa423cb.md";